import React, { useCallback, useState } from "react";
import { marked } from 'marked';
import { Modal, useModal } from "./Modal";
import { makeCdnUrl } from 'motion-master-client';

const MmChangelog = () => {
  const { isOpen, open, close } = useModal();
  const [changelogV4, setChangelogV4] = useState(null);
  const [changelogV5, setChangelogV5] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const changelog4Url = makeCdnUrl(`/motion-master-v4-changelog.md`);
  const changelog5Url = makeCdnUrl(`/motion-master-v5-changelog.md`);

  const handleModalOpen = () => {
    fetchChangelog();
    open();
  };

  const fetchChangelog = useCallback(() => {
    if (isFetching) return;
    setIsFetching(true);

    Promise.all([
      fetch(changelog4Url).then((res) => {
        if (res.ok) return res.text();
        throw new Error(`v4: ${res.statusText}`);
      }),
      fetch(changelog5Url).then((res) => {
        if (res.ok) return res.text();
        throw new Error(`v5: ${res.statusText}`);
      }),
    ])
      .then(([v4md, v5md]) => {
        setFetchError(null);
        setChangelogV4(marked.parse(v4md ?? ""));
        setChangelogV5(marked.parse(v5md ?? ""));
      })
      .catch((res) => {
        console.error(res);
        setFetchError(res);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [changelog4Url, changelog5Url, isFetching]);

  return (
    <>
      <button type="button" onClick={handleModalOpen} className="dropdown-item">
        View Motion Master Changelog
      </button>
      <Modal title="Motion Master" isOpen={isOpen} size="lg" isScrollable={true} onClose={close}>
        {isFetching && !fetchError && <strong role="status">Loading...</strong>}
        {changelogV5 && <div dangerouslySetInnerHTML={{ __html: changelogV5 }}></div>}
        <hr></hr>
        {changelogV4 && <div dangerouslySetInnerHTML={{ __html: changelogV4 }}></div>}
        {fetchError && <strong>{fetchError.message}</strong>}
      </Modal>
    </>
  );
};

export default MmChangelog;
